import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import type { Params } from '@angular/router';
import {
  CMS_PAGE_ROUTE_CONTEXT,
  CmsPageRouteContext,
  OrderHistoryHelperService,
  OrderHistoryNavigationService,
  OrderHistoryOverviewComponent,
  OrderHistoryRecordComponent,
} from '@libs/services/components';

@Component({
  selector: 'ui-order-history',
  templateUrl: './order-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [OrderHistoryHelperService, OrderHistoryNavigationService],
  imports: [OrderHistoryOverviewComponent, OrderHistoryRecordComponent],
})
export class OrderHistoryComponent {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly routeContext: CmsPageRouteContext = inject(CMS_PAGE_ROUTE_CONTEXT);

  public readonly orderId: string | undefined = this.routeContext.urlSuffix;
  public readonly queryParams: Signal<Params> = toSignal(this.activatedRoute.queryParams, {
    initialValue: this.activatedRoute.snapshot.queryParams,
  });
}
